export const BRAND = {
  name: "VIC WRAP STUDIO",
  phone: "+61 433 865 434",
  phoneHref: "tel:+61433865434",
  email: "info@vicwrapstudio.com.au",
  emailHref: "mailto:info@vicwrapstudio.com.au",
  location: "Melbourne, Victoria",
};

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const preselectServiceAndQuote = (serviceTitle) => {
  window.dispatchEvent(new CustomEvent("vic:preselect-service", { detail: serviceTitle }));
  scrollToId("quote");
};

const img = (id, w = 1400, extra = "") =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80${extra}`;

export const IMAGES = {
  heroCar: img("photo-1617814076231-2c58846db944", 2000),
  wrapGrille: img("photo-1677793835534-62e7547f95f2"),
  tinting: img("photo-1699897483215-a66a9ca292b3"),
  building: img("photo-1481026469463-66327c86e544"),
  craftsman: img("photo-1708805282706-f44730b7e527"),
  bmw: img("photo-1616612164847-3069f142e232"),
  officeGlass: img("photo-1523477593243-78bbf626fd3b"),
};

export const NAV_LINKS = [
  { label: "HOME", id: "home", testid: "nav-link-home" },
  { label: "SERVICES", id: "services", testid: "nav-link-services" },
  { label: "GRAPHIC DESIGN", id: "graphic-design", testid: "nav-link-graphic-design" },
  { label: "VEHICLE WRAPPING", id: "vehicle-wrapping", testid: "nav-link-vehicle-wrapping" },
  { label: "WINDOW FILM", id: "window-film", testid: "nav-link-window-film" },
  { label: "PORTFOLIO", id: "portfolio", testid: "nav-link-portfolio" },
  { label: "ABOUT", id: "about", testid: "nav-link-about" },
  { label: "CONTACT", id: "contact", testid: "nav-link-contact" },
];

export const SERVICES = [
  {
    id: "graphic-design",
    num: "01",
    title: "Graphic Design",
    seo: "Graphic Design Melbourne",
    desc: "Brand-first design crafted in-house — from logo suites to press-ready packaging. Every file leaves our studio production-perfect, so what you approve on screen is exactly what hits the street.",
    items: [
      "Logo & Branding",
      "Marketing Materials",
      "Business Cards",
      "Flyers & Brochures",
      "Social Media Graphics",
      "Print-Ready Artwork",
      "Packaging Design",
      "Prepress & Production",
    ],
    image: "/images/service-graphic-design.webp",
    imageAlt: "Graphic Design Melbourne — van livery design in progress at vicwrap studio",
    testid: "service-card-graphic-design",
  },
  {
    id: "concept-design",
    num: "02",
    title: "Concept & Creative Design",
    seo: "Concept & Creative Design Studio",
    desc: "See it before we build it. We develop high-resolution concepts for wraps, signage and windows so you can sign off on the exact look — no surprises, no guesswork.",
    items: [
      "Vehicle Wrap Concepts",
      "Signage Concepts",
      "Window Graphic Concepts",
      "Advertising Concepts",
      "Custom Visual Solutions",
      "Creative Ideas for Business & Vehicles",
    ],
    image: "/images/service-concept.webp",
    imageAlt: "Concept design in progress — vector line-art artwork in Adobe Illustrator at vicwrap studio Melbourne",
    testid: "service-card-concept-creative",
  },
  {
    id: "signage",
    num: "03",
    title: "Signage & Graphics",
    seo: "Signage Installation Melbourne",
    desc: "Shopfronts, walls and windows that pull people in. We design, print, supply and professionally install commercial-grade signage and vinyl graphics across Melbourne.",
    items: [
      "Business Signage",
      "Vinyl Lettering",
      "Decals & Stickers",
      "Window Graphics",
      "Wall Graphics",
      "Frosted Vinyl",
      "One-Way Vision / Perforated Vinyl",
      "Supply & Professional Installation",
    ],
    image: "/images/service-signage.webp",
    imageAlt: "Signage Installation Melbourne — 80 Market 3D lettering entrance sign by vicwrap studio",
    testid: "service-card-signage-graphics",
  },
  {
    id: "vehicle-wrapping",
    num: "04",
    title: "Vehicle Wrapping",
    seo: "Vehicle Wrapping Melbourne",
    desc: "Full colour changes, commercial fleet branding and everything between. Premium cast vinyl, heat-formed around every curve by installers who treat your vehicle like their own.",
    items: [
      "Full Vehicle Wraps",
      "Partial Vehicle Wraps",
      "Commercial Vehicle Branding",
      "Printed Vinyl Graphics",
      "Decals & Lettering",
      "Wrap Design & Concept",
      "Professional Vinyl Application",
      "Fleet Branding",
    ],
    image: "/images/service-wrapping.webp",
    imageAlt: "Vehicle Wrapping Melbourne — carbon vinyl mirror wrap being applied at vicwrap studio",
    testid: "service-card-vehicle-wrapping",
  },
  {
    id: "window-tinting",
    num: "05",
    title: "Car Window Tinting",
    seo: "Car Window Tinting Melbourne",
    desc: "Ceramic and carbon films cut with precision templates and applied in a clean, controlled environment. Cooler cabin, sharper look, zero bubbles — guaranteed.",
    items: [
      "Front Window Tinting",
      "Rear Window Tinting",
      "Rear Windshield Tinting",
      "Ceramic & Carbon Tint Options",
      "Removal of Existing Tint",
      "Professional Installation",
      "Clean, Bubble-Free Application",
    ],
    image: "/images/service-tinting.webp",
    imageAlt: "Car Window Tinting Melbourne — before and after ceramic tint by vicwrap studio",
    testid: "service-card-car-tinting",
  },
  {
    id: "window-film",
    num: "06",
    title: "Residential & Commercial Window Film",
    seo: "Window Film Installation Melbourne",
    desc: "Privacy, heat control and security films for homes, offices and shopfronts. From frosted meeting rooms to whole-building solar control — measured, cut and installed to last.",
    items: [
      "Privacy Film",
      "Frosted & Decorative Film",
      "One-Way Privacy Film",
      "Solar & Heat-Control Film",
      "Safety & Security Film",
      "Office & Commercial Window Film",
      "Glass Graphics & Vinyl",
      "Residential Window Film",
    ],
    image: "/images/service-window-film.webp",
    imageAlt: "Commercial Window Film Melbourne — frosted office film with vicwrap studio branding",
    testid: "service-card-architectural-film",
  },
];

export const SERVICE_OPTIONS = [
  "Graphic Design",
  "Concept & Creative Design",
  "Signage & Graphics",
  "Vehicle Wrapping",
  "Car Window Tinting",
  "Residential Window Film",
  "Commercial Window Film",
  "Other / Not Sure Yet",
];

export const MARQUEE_ITEMS = [
  "PRECISION CAD TEMPLATES",
  "CERAMIC IR HEAT REJECTION",
  "100% BUBBLE-FREE APPLICATION",
  "COMMERCIAL FLEET BRANDING",
  "MELBOURNE-WIDE SUPPLY & INSTALL",
  "IN-HOUSE DESIGN & PREPRESS",
  "RESIDENTIAL & COMMERCIAL FILM",
];

export const SOCIALS = [
  { id: "instagram", label: "Instagram", href: "https://www.instagram.com/VICWRAP_STUDIO" },
  { id: "facebook", label: "Facebook", href: "https://www.facebook.com/vicwrapstudio" },
  { id: "linkedin", label: "Bardia Bahrami on LinkedIn", href: "https://www.linkedin.com/in/bardiabahrami1021" },
];

export const CLIENTS = [
  { id: "australia-post", name: "Australia Post", logo: null },
  { id: "victoria-police", name: "Victoria Police", logo: null },
  { id: "air-control", name: "Air Control Australia", logo: null },
  { id: "m-group", name: "M Group Electric", logo: null },
  { id: "isbell", name: "Isbell Services", logo: null },
  { id: "premier", name: "Premier Service Solutions", logo: null },
  { id: "zanga", name: "Zanga Imports", logo: null },
  { id: "semc", name: "SEMC", logo: null },
  { id: "westend-tyres", name: "Westend Tyres", logo: null },
  { id: "brotomotiv", name: "Brotomotiv", logo: null },
  { id: "ems-auto", name: "EMS Auto", logo: null },
  { id: "80-market", name: "80 Market", logo: null },
];

export const CONCEPT_GALLERY = [
  { title: "Australia Post — Fleet Van Livery", tag: "Fleet Concept", image: "/images/concept-auspost.webp" },
  { title: "Victoria Police — Ranger Livery", tag: "Emergency Fleet Concept", image: "/images/concept-police.webp" },
  { title: "Air Control Australia — HiAce Wrap", tag: "Commercial Van Concept", image: "/images/concept-aircontrol.webp" },
  { title: "Plumber HiAce — Illustrated Wrap", tag: "Creative Van Concept", image: "/images/concept-plumber.webp" },
  { title: "M Group Electric — Sprinter Livery", tag: "Trade Fleet Concept", image: "/images/concept-mgroup.webp" },
  { title: "Isbell Services — NV200 Wrap", tag: "Multi-Angle Concept", image: "/images/concept-isbell.webp" },
  { title: "Premier Service Solutions — Transit", tag: "Commercial Van Concept", image: "/images/concept-premier.webp" },
  { title: "Orange & Navy Swirl — Van Template", tag: "Design Study", image: "/images/concept-swirl.webp" },
  { title: "Trail Stripe Kit — Transit Custom", tag: "Accent Stripe Concept", image: "/images/concept-trail.webp" },
];


export const PORTFOLIO_TABS = [
  { id: "all", label: "All Work", testid: "portfolio-tab-all" },
  { id: "Vehicle Wrapping", label: "Vehicle Wrapping", testid: "portfolio-tab-vehicle-wrapping" },
  { id: "Signage", label: "Signage", testid: "portfolio-tab-signage" },
  { id: "Window Film", label: "Window Film", testid: "portfolio-tab-window-film" },
  { id: "Window Graphics", label: "Window Graphics", testid: "portfolio-tab-window-graphics" },
  { id: "Graphic Design", label: "Graphic Design", testid: "portfolio-tab-graphic-design" },
  { id: "Concepts", label: "Concepts", testid: "portfolio-tab-concepts" },
];

export const PORTFOLIO_ITEMS = [
  { title: "Carbon Fibre Mirror Wrap", cat: "Vehicle Wrapping", tag: "Carbon Vinyl", image: "/images/service-wrapping.webp" },
  { title: "Matte Grey 370Z — Racing Stripes", cat: "Vehicle Wrapping", tag: "Matte Wrap + Stripes", image: "/images/wrap-370z.webp" },
  { title: "Carbon Fender Wrap — Draping", cat: "Vehicle Wrapping", tag: "Carbon Vinyl", image: "/images/wrap-draping.webp" },
  { title: "Ceramic Tint — Before & After", cat: "Window Film", tag: "Ceramic IR Film", image: "/images/service-tinting.webp" },
  { title: "Office Frosted Film", cat: "Window Graphics", tag: "Frosted + Branding", image: "/images/service-window-film.webp" },
  { title: "Office Partition Frosting", cat: "Window Film", tag: "Commercial Privacy", image: "/images/film-office.webp" },
  { title: "Front Door Privacy Frosting", cat: "Window Film", tag: "Residential", image: "/images/film-door.webp" },
  { title: "Home Window Privacy Film", cat: "Window Film", tag: "Residential", image: "/images/film-window.webp" },
  { title: "Bathroom Privacy Windows", cat: "Window Film", tag: "Residential", image: "/images/film-bathroom.webp" },
  { title: "Balcony Sliding Door — Frosted Privacy Film", cat: "Window Film", tag: "Residential", image: "/images/portfolio-balcony-frost.webp" },
  { title: "Apartment Fluted Privacy Film", cat: "Window Film", tag: "Before & After", image: "/images/portfolio-film-vertical.webp" },
  { title: "Westend Tyres — Shopfront Window Graphics", cat: "Window Graphics", tag: "Before & After", image: "/images/portfolio-westend.webp" },
  { title: "Cutting Film Into Shape", cat: "Window Film", tag: "Install Process", image: "/images/portfolio-cutting.webp" },
  { title: "SEMC — Clear Acrylic Sign", cat: "Signage", tag: "Design + Install", image: "/images/portfolio-semc.webp" },
  { title: "SEMC — 3D Lettering Wall Sign", cat: "Signage", tag: "Design + Install", image: "/images/portfolio-lettering.webp" },
  { title: "Brotomotiv Shopfront Signage", cat: "Signage", tag: "ACM Panel", image: "/images/portfolio-brotomotiv.webp" },
  { title: "80 Market — Entrance Lettering Sign", cat: "Signage", tag: "Design + Install", image: "/images/portfolio-80market.webp" },
  { title: "EMS Auto — Panel Signage Suite", cat: "Signage", tag: "Supply + Install", image: "/images/signage-collage.webp" },
  { title: "Australia Post HiAce — Wrap Artwork In Photoshop", cat: "Graphic Design", tag: "Print-Ready Artwork", image: "/images/service-graphic-design.webp" },
  { title: "Alpine Stealth Van — Wrap Concept", cat: "Concepts", tag: "Pre-Build Render", image: "/images/portfolio-alpine.webp" },
  { title: "Plumber HiAce — Illustrated Wrap Concept", cat: "Concepts", tag: "Pre-Build Render", image: "/images/portfolio-plumber-side.webp" },
  { title: "Zanga Imports — HiAce Livery (Driver Side)", cat: "Concepts", tag: "Fleet Concept", image: "/images/portfolio-zanga-driver.webp" },
  { title: "Zanga Imports — HiAce Livery (Passenger Side)", cat: "Concepts", tag: "Fleet Concept", image: "/images/portfolio-zanga-passenger.webp" },
  { title: "SUV Wrap Design In Progress", cat: "Concepts", tag: "Design Process", image: "/images/concept-suv.webp" },
];

export const PROCESS_STEPS = [
  {
    num: "01",
    title: "DISCUSS",
    desc: "Tell us about your project — the vehicle, the shopfront, the office. We scope measurements, goals and budget.",
    testid: "process-step-1-discuss",
  },
  {
    num: "02",
    title: "CONCEPT",
    desc: "We develop the design or recommend the right film and material solution for the job.",
    testid: "process-step-2-concept",
  },
  {
    num: "03",
    title: "QUOTE",
    desc: "Receive a clear, itemised and completely free quotation. No hidden fees, no pressure.",
    testid: "process-step-3-quote",
  },
  {
    num: "04",
    title: "INSTALL",
    desc: "Professional installation with clean finishing, post-heat cure and a final inspection sign-off.",
    testid: "process-step-4-install",
  },
];

export const SERVICE_AREAS = [
  "Melbourne CBD",
  "Inner East",
  "South East",
  "Northern Suburbs",
  "Western Suburbs",
  "Mornington Peninsula",
];
